import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pa_subheadline: {
    id: 'x7qCSm',
    defaultMessage:
      'Estimate your IBM watsonx Code Assistant for Red Hat Ansible Lightspeed price based on the scope of your needs:',
  },
  labeltext_ansibleDeveloper: {
    id: 'ujNuUT',
    defaultMessage: 'Select the number of Ansible developers',
  },
  labeltext_ansibleTask: {
    id: 'XmAlfx',
    defaultMessage: 'Number of Ansible tasks per developer in a month',
  },
  labeltext_numberPerYear: {
    id: 'm9WgSp',
    defaultMessage: 'Number of times per year planning to tune the model',
  },
  tooltip_ansibleDeveloper: {
    id: 'ALA2Wu',
    defaultMessage:
      'On average, Ansible development teams are comprised of 60 developers or fewer. For enterprise-grade development teams, the number of developers can drastically increase into the hundreds or thousands.',
  },
  tooltip_ansibleTask: {
    id: 'lY2AM+',
    defaultMessage:
      'On average, a developer will make an estimated 200 Ansible tasks a month.',
  },
  tooltip_numberPerYear: {
    id: 'gxFCg7',
    defaultMessage:
      'On average, organizations will need to tune the base code model with their own datasets four to six times per year.',
  },
  estimated_price: {
    id: 'lSIpRl',
    defaultMessage: 'Estimated monthly price',
  },
  asterisk_price: {
    id: 'k6nzq4',
    defaultMessage: ' Prices shown do not include tax.',
  },
  suggested_title: {
    id: 'q+eu0I',
    defaultMessage: 'Suggested tier',
  },
  standard_title: {
    id: 'cb2kY6',
    defaultMessage: 'Standard',
  },
  instance_title: {
    id: 'VA8QGW',
    defaultMessage: 'Instance fee',
  },
  ansible_task_title: {
    id: 'Eq4fVP',
    defaultMessage: 'Total Ansible tasks per month',
  },
  excess_title: {
    id: 'O+R7Hi',
    defaultMessage: 'Excess RU over 660',
  },
  tunning_title: {
    id: 'Cs17qa',
    defaultMessage: 'Tuning hour',
  },
  footnote_one: {
    id: 'kNT7DD',
    defaultMessage:
      'Calculated prices are estimates provided for planning purposes only, taking into account potential IBM discounts, and are not a formal offer from IBM or an IBM Business Partner. The estimation may reflect the total discounted price. Certain factors such as configuration, add-ons, additional requirements, or related services will affect the final price. IBM Business Partners set and provide their own IBM watsonx Code Assistant for Ansible Lightspeed pricing, and neither IBM nor IBM Business Partners are bound by the provided estimate.',
  },
  CTA_01: {
    id: 'qOXENr',
    defaultMessage: 'Book a meeting',
  },
  CTA_02: {
    id: '9QXm1E',
    defaultMessage: 'Get Started',
  },
  get_quote_button: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  get_trial_button: {
    id: '01KAwY',
    defaultMessage: 'Sign up for the trial',
  },
  tier_essential: {
    id: 'rfzuQv',
    defaultMessage: 'Essential',
  },
  tier_standard: {
    id: 'cb2kY6',
    defaultMessage: 'Standard',
  },
  error_price: {
    id: 'Gbumi0',
    defaultMessage: 'Cannot use Essential Plan because tuning is needed',
  },

  preferred_bp: {
    id: '9Auwhe',
    defaultMessage: 'Preferred IBM Business Partner',
  },
  return_to_estimator: {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  explorer_title: {
    id: 'mJN/zn',
    defaultMessage: 'Explorer',
  },
  user_title: {
    id: 'EwRIOm',
    defaultMessage: 'User',
  },
  toggle_tittle: {
    id: 'iGK2kJ',
    defaultMessage: 'Do you have Ansible Automation Platform (AAP)?',
  },
  toggle__tooltip: {
    id: '01qBJu',
    defaultMessage:
      'Red Hat Ansible Automation Platform is an end-to-end automation platform to configure systems, deploy software, and orchestrate advanced workflows. The platform is a pre-requisite for watsonx Code Assistant for Red Hat Ansible Lightspeed and is available for purchase through Red Hat.',
  },
  toggle_yes: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
  },
  toggle_no: {
    id: 'oUWADl',
    defaultMessage: 'No',
  },
});

export default messages;
